/**
 * Rotas de Navegação
 * atualização: 11/10/24 | 15h26 | inclusão de 2 novas rotas de colaborador (novo e edição)
 * atualização: 16/12/24 | 10h59 | acrescentado as rotas de login e demais do "admin"
 * atualização: 31/12/25 | 12h05 | separamos todas as rotas em módulos incluindo o lazy e o suspense para executar somente quando forem necessárias
 */



import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

// **** todas as páginas

        // **** páginas iniciais (públicas)
        import Site from "../site/pages/home";
        import PrecosCRM from "../site/pages/precoscrm";
        import LoginGlobal from "../app/Login/loginmodal";
        import NovaContaGlobal from "../app/NovaConta/novacontamodal";
        import ResetSenha from "../app/ResetSenha/resetsenha";
        import ResetSenhaCV from "../app/ResetSenha/resetsenhacv";

        // **** rotas públicas 
        import { publicRoutes } from "./publicRoutes";

        // **** rotas do cliente (protegidas)
        import { clienteRoutes } from "./clienteRoutes";
import { prestadorRoutes } from "./prestadorRoutes";
import { colaboradorRoutes } from "./colaboradorRoutes";


function Rotas(){

    return <BrowserRouter>
            <Routes>
                {/* *** rotas públicas *** */}
                    <Route path="/" element={<Site />} />
                    <Route path="/precos" element={<PrecosCRM />} />
                    <Route path="/app/login" element={<LoginGlobal />} />
                    <Route path="/app/novaconta" element={<NovaContaGlobal />} />
                    <Route path="/app/resetsenha" element={<ResetSenha />} />
                    <Route path="/app/resetsenha/cv" element={<ResetSenhaCV />} />

                {/* *** rotas públicas - array de rotas *** */}         
                {publicRoutes.map(route => <Route key={route.path} {...route} />)}

                {/* *** rotas protegidas - cliente *** */}
                {clienteRoutes.map(route => <Route key={route.path} {...route} />)}
                {prestadorRoutes.map(route => <Route key={route.path} {...route} />)}
                {colaboradorRoutes.map(route => <Route key={route.path} {...route} />)}

                {/* *** rota 404 *** */}
                    <Route path="*" element={<Navigate to="/app/login" />} />

            </Routes>
    </BrowserRouter>
}

export default Rotas;